export default function Hero() {
  return (
    <section className="relative h-[70vh] min-h-[600px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/f99639ebc7bfcad8022a6b3e88df7cea.jpeg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>
      
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 text-center">
        <div className="inline-block bg-[#8B1538] text-white px-6 py-2 rounded-full text-sm font-bold mb-6 uppercase tracking-wider">
          Creating Value from Waste Materials
        </div>
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 font-['Montserrat']">
          CHROME <span className="text-[#8B1538]">PROCESSING</span>
        </h1>
        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-['Lato'] leading-relaxed">
          Transforming raw materials into premium chrome concentrate through innovative processing and strategic partnerships
        </p>
        <div className="flex flex-wrap gap-4 justify-center mt-10">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-lg">
            <div className="text-3xl font-bold text-white">1000MT</div>
            <div className="text-sm text-white/80">Weekly Capacity</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-lg">
            <div className="text-3xl font-bold text-white">8+</div>
            <div className="text-sm text-white/80">Years Experience</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-lg">
            <div className="text-3xl font-bold text-white">Rustenburg</div>
            <div className="text-sm text-white/80">Processing Plant</div>
          </div>
        </div>
      </div>
    </section>
  );
}
